import CancelAccount from "@/views/privacy/CancelAccount";
import CancelConditions from "@/views/privacy/CancelConditions";
import AuthCenter from "@/views/privacy/AuthCenter";
import CancelContent from "@/views/privacy/CancelContent";
import Agreement from "@/views/privacy/Agreement";

const routes = [
    {
        path: "/cancelAccount",
        name: "CancelAccount",
        meta: {
            title: "注销账号"
        },
        component: CancelAccount
    },
    {
        path: "/cancelConditions",
        name: "CancelConditions",
        meta: {
            title: "注销账号"
        },
        component: CancelConditions
    },
    {
        path: "/authCenter",
        name: "AuthCenter",
        meta: {
            title: "验证中心"
        },
        component: AuthCenter
    },
    {
        path: "/cancelContent",
        name: "CancelContent",
        meta: {
            title: "注销账号"
        },
        component: CancelContent
    },
    {
        path: "/agreement",
        name: "Agreement",
        meta: {
            title: "用户注销协议"
        },
        component: Agreement
    },
];
export default routes;